import template from './dashboard-date-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController } from 'angular';
import type { I18n } from '../../../i18n/mx-internationalization';

export class DashboardDateFilterController implements IComponentController {
	filter!: InteractiveFilter;

	private _valueFrom?: Date;
	private _valueTo?: Date;

	static readonly $inject = ['mx.internationalization'];
	constructor(private readonly i18n: I18n) {}

	$onInit() {
		this.handleExternalChanges();
		this.updateFilterValue();

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});
	}

	private handleExternalChanges() {
		this._valueFrom = undefined;
		this._valueTo = undefined;

		if (Array.isArray(this.filter.value)) {
			const [from, to] = this.filter.value;
			if (typeof from === 'string') {
				const valueFrom = new Date(from);
				if (!isNaN(valueFrom.getTime())) {
					this._valueFrom = valueFrom;
				}
			}

			if (typeof to === 'string') {
				const valueTo = new Date(to);
				if (!isNaN(valueTo.getTime())) {
					this._valueTo = valueTo;
				}
			}
		}
	}

	get valueFrom() {
		return this._valueFrom;
	}

	set valueFrom(newValue: Date | undefined) {
		this._valueFrom = newValue === null ? undefined : newValue;
		this.updateFilterValue();
	}

	get valueTo() {
		return this._valueTo;
	}

	set valueTo(newValue: Date | undefined) {
		this._valueTo = newValue === null ? undefined : newValue;
		this.updateFilterValue();
	}

	private updateFilterValue() {
		if (!this._valueFrom && !this._valueTo) {
			this.filter.clear();
			return;
		}
		let valueTo: string | undefined;
		if (this._valueTo instanceof Date) {
			const valueToDate = new Date(this._valueTo.toISOString());
			valueToDate.setDate(this._valueTo.getDate() + 1);
			valueTo = valueToDate.toISOString();
		}

		const stringValueFrom = this._valueFrom instanceof Date ? this.i18n.formatDate(this._valueFrom, 'longDate') : '';
		const stringValueTo = this._valueTo instanceof Date ? this.i18n.formatDate(this._valueTo, 'longDate') : '';

		this.filter.setValue([this._valueFrom?.toISOString(), valueTo], this.filter.operators.Between.getFullLabel(this.filter.title, [stringValueFrom, stringValueTo]));
	}
}

export const DashboardDateFilterComponent = {
	name: 'mxDashboardDateFilter',
	controller: DashboardDateFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
